var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 151,
    viewBox: "0 0 301 151",
    width: 301,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5.5h300v150h-300z",
    fill: "#002395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80 .5h150v150z",
    fill: "#fecb00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.376 10.341-8.376-6.086-8.376 6.086 3.207-9.841h10.338zm23.927 2.818-8.376 6.086 3.199 9.846-8.376-6.085-8.376 6.085 3.2-9.846-8.376-6.086h10.353l3.199-9.846 3.2 9.846zm18.75 18.75-8.376 6.086 3.199 9.846-8.376-6.085-8.376 6.085 3.2-9.846-8.376-6.086h10.353l3.199-9.846 3.2 9.846zm18.75 18.759-8.376 6.086 3.199 9.847-8.376-6.086-8.376 6.086 3.2-9.847-8.376-6.086h10.353l3.199-9.846 3.2 9.846zm18.752 18.748-8.376 6.086 3.2 9.846-8.376-6.085-8.376 6.085 3.199-9.846-8.376-6.086h10.353l3.2-9.846 3.199 9.846zm18.744 18.751-8.376 6.086 3.2 9.846-8.376-6.086-8.376 6.086 3.199-9.846-8.376-6.086h10.353l3.2-9.847 3.199 9.847zm18.758 18.756-8.375 6.085 3.199 9.847-8.376-6.086-8.376 6.086 3.199-9.847-8.376-6.085h10.354l3.199-9.847 3.199 9.847zm18.749 18.741-8.376 6.086 3.2 9.846-8.376-6.085-8.376 6.085 3.199-9.846-8.376-6.086h10.354l3.199-9.846 3.199 9.846zm18.747 18.745h-10.353l-3.2-9.846-3.199 9.846h-10.353l8.376 6.086h10.353z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa);
export default __webpack_public_path__ + "static/media/BA.3ea9a5809fe90ac9acd9761d35011a1b.svg";
export { ForwardRef as ReactComponent };